<div id="product" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg"
       [ngStyle]="{'background-color': (user && user.color ? colorShema[user.color] : colorShema['basic'])}"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      @if (user) {
        <div class="buttons-header" fxLayout="row" fxLayoutAlign="start center">
          @if (user && user.verify && !validateButton) {
            <button class="mr-0 mr-sm-16" mat-icon-button (click)="goBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
          }
          @if (user && (!user.verify || validateButton)) {
            <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/frontusersnoactive'">
              <mat-icon>arrow_back</mat-icon>
            </button>
          }
          <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom
               [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
            @if (user && img && user.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" [src]="getImage(img)">
            }
            @if (user && !user.logo && user.frontRole.name === 'student' && user.gender === 'male' && user.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" class="product-image"
                   [src]="'assets/images/studentMale.jpg'">
            }
            @if (user && !user.logo && user.frontRole.name === 'student' && user.gender === 'female' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" class="product-image"
                   [src]="'assets/images/studentFemale.jpg'">
            }
            @if (user && !user.logo && user.frontRole.name === 'parent' && user.gender === 'female' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" class="product-image"
                   [src]="'assets/images/mother.jpg'">
            }
            @if (user && !user.logo && user.frontRole.name === 'parent' && user.gender === 'male' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" class="product-image"
                   [src]="'assets/images/father.jpg'">
            }
            @if (!user?.showFoto || (user?.showFoto && !user?.logo && user?.gender === 'diverse')) {
              <div [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"
                   class="product-image color-logo"
                   [style.backgroundColor]="(user?.logoColor && !user?.showFoto )? user?.logoColor : '#B0B0B0'">
                {{ user.firstName && user.firstName[0] && user.firstName[0].toUpperCase() }}{{ user.lastName && user.lastName[0] && user.lastName[0].toUpperCase() }}
              </div>
            }
          </div>
          <div fxLayout="column" fxLayoutAlign="start start"
               *fuseIfOnDom [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            @if (user) {
              <div class="h2">
                {{ user.lastName + ' ' + user.firstName }}
              </div>
            }
            <div class="subtitle secondary-text">
              <span>{{ 'frontUser.user_detail' | translate }}</span>
            </div>
          </div>
          @if (user) {
            <div class="main-information">
              <h1>{{ user?.organization?.organizationType?.name }} {{ user?.organization?.name }}</h1>
              <h1>{{ user?.targetGroup?.ageMask }}</h1>
            </div>
          }
        </div>
      }
      <!-- / APP TITLE -->


      <div>


        @if (user && !user.verify) {
          <button mat-button [matMenuTriggerFor]="menu" class="validation-button">
            <mat-icon>settings</mat-icon>
            <span>{{ 'frontUser.validation' | translate }}</span>
          </button>
        }
        <mat-menu #menu="matMenu">
          @if (user && !user.verify) {
            <button mat-menu-item
                    (click)="verify('verify')">
              <span>{{ 'main.verify' | translate }}</span>
            </button>
          }

          @if (user && !user.verify) {
            <button mat-menu-item
                    (click)="verify('rejection')">
              <span>{{ 'main.rejection' | translate }}</span>
            </button>
          }

          @if (user && !user.verify) {
            <button mat-menu-item
                    (click)="verify('correction')">
              <span>{{ 'main.correction' | translate }}</span>
            </button>
          }
        </mat-menu>

        @if (user?.deleteRequest) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0 deleteRequest"
                  (click)="deleteProfile()">
            <span>{{ 'complete_delete_request' | translate }}</span>
          </button>
        }

        @if (user?.deleteRequest) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="deleteRequest()">
            <span>{{ 'delete_delete_request' | translate }}</span>
          </button>
        }

        @if (editing) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  [disabled]="formGroup && formGroup.invalid"
                  (click)="updateUser()">
            <span>{{ 'main.update' | translate }}</span>
          </button>
        }

        @if (editing) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="cancelEdit()">
            <span>{{ 'main.cancel' | translate }}</span>
          </button>
        }

        @if (!editing) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="startEdit()">
            <span>{{ 'main.edit' | translate }}</span>
          </button>
        }

        @if (user && user.verify && user.email) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="sendEmail()">
            <span>{{ 'main.sendEmail' | translate }}</span>
          </button>
        }

        @if (editing) {
          <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="deleteUser()">
            <span>{{ 'main.delete' | translate }}</span>
          </button>
        }


        <mat-button-toggle-group #group="matButtonToggleGroup" class="communication-action"
                                 (change)="communicationAction($event)">
          @if (eCall) {
            <mat-button-toggle value="sms" matTooltip="SMS">
              <mat-icon>textsms</mat-icon>
            </mat-button-toggle>
          }
          @if (whatsapp) {
            <mat-button-toggle value="whatsapp" matTooltip="WhatsApp">
              <mat-icon>call</mat-icon>
            </mat-button-toggle>
          }
          <mat-button-toggle value="mail" matTooltip="MAIL">
            <mat-icon>email</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="serial" matTooltip="{{'frontUser.Serial_Letter' | translate}}">
            <mat-icon>receipt</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

      </div>

    </div>
    <!-- / HEADER -->

    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      @if (editing) {
        <div class="content">
          <div class="content-block">
            <cropper [avatar]="logo" [page]="'fr-user-detail'" (sendImg)="setImg($event)"></cropper>
            <div>
              <div class="relative-title">
                <div class="rt-title">{{ 'adults_reference' | translate }}</div>
                <!--              <div class="rt-button" (click)="addParent('new', null)">+ {{'add' | translate}}</div>-->
              </div>
              @if (!connectedAdult.length && !adultExist) {
                <div class="relative-title">
                  <div class="rt-title"
                       style="text-align: center; font-size: 18px">{{ 'no_relative_connection' | translate }}
                  </div>
                </div>
              }
              <relative-page [users]="connectedRelatives" [user]="user"
                             [clanUsers]="connectedAdult" [ageType]="'adult'"
                             (update)="getConnection(user.id)"
                             (updateClan)="getClan()" [role]="2"
                             [type]="parentPage ? 'parent' : 'student'"></relative-page>
              @if (!studentPage) {
                <div class="relative-title">
                  <div class="rt-title">{{ 'children' | translate }}</div>
                  <!--              <div class="rt-button" (click)="addChildren('new', null)">+ {{'add' | translate}}</div>-->
                </div>
              }
              @if (studentPage) {
                <div class="relative-title">
                  <div class="rt-title">{{ 'siblings' | translate }}</div>
                </div>
              }
              @if (!connectedYoung.length && !youngExist) {
                <div class="relative-title">
                  <div class="rt-title"
                       style="text-align: center; font-size: 18px">{{ 'no_relative_connection' | translate }}
                  </div>
                </div>
              }
              <relative-page [users]="connectedRelatives" [user]="user" [ageType]="'young'"
                             [clanUsers]="connectedYoung" [role]="1"
                             (update)="getConnection(user.id)"
                             (updateClan)="getClan()"
                             [type]="parentPage ? 'parent' : 'student'"></relative-page>
              <div class="relative-title" style="justify-content: left">
                <div class="rt-button" (click)="addPartnerCheck('new', null)">
                  <span>{{ 'add_person' | translate }}</span>
                  <mat-icon>add</mat-icon>
                </div>
              </div>
            </div>
            <div class="p-16">
              <document-tab (filesToUpload)="filesForUpload($event)" [type]="'frontUser'" [id]="id"
                            (filesAccess)="setFileAccess($event)" [uploadedFiles]="files"></document-tab>
            </div>
            @if (user.showFollowing) {
              <div class="following-organization">
                <div class="relative-title">
                  <div class="rt-title">{{ 'frontUser.userFollowingOrg' | translate }}</div>
                  @if (!addingOrganization && organizationForFollowing.length) {
                    <div class="rt-button margin-right"
                         (click)="addFollowOrganization()">+ {{ 'add' | translate }}
                    </div>
                  }
                </div>
                @if (addingOrganization) {
                  <div class="add-follow-organization">
                    <mat-form-field class="width-100 select-org">
                      <mat-label>{{ 'pls_choose_org' | translate }}</mat-label>
                      <input type="text"
                             aria-label="Organization"
                             matInput
                             [formControl]="selectedOrg"
                             [matAutocomplete]="auto">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        @for (option of filteredOptions | async; track option) {
                          <mat-option [value]="option">
                            {{ option.name }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <button mat-raised-button [disabled]="!selectedOrgObj"
                            (click)="saveFollowingOrg()">{{ 'main.save' | translate }}
                    </button>
                  </div>
                }
                <div class="organization-list">
                  @for (org of followingOranization; track org.id) {
                    <div class="organization">
                      <div class="organization-name">{{ org.organization.name }}</div>
                      <div class="remove-org" (click)="removeFollowingOrg(org.id)">
                        <mat-icon>delete</mat-icon>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="content-block">
            <form [formGroup]="formGroup" class="canton-form">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'user.role' | translate }}</mat-label>
                <mat-select formControlName="frontRoleId" required>
                  @for (role of roles; track role.value) {
                    <mat-option [value]="role.value">
                      {{ role.label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (formGroup.get('firstName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.firstName' | translate }}</mat-label>
                  <input formControlName="firstName" matInput required>
                </mat-form-field>
              }
              @if (formGroup.get('lastName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.lastName' | translate }}</mat-label>
                  <input formControlName="lastName" matInput required>
                </mat-form-field>
              }
              @if (formGroup.get('nickName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.nickName' | translate }}</mat-label>
                  <input formControlName="nickName" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('email')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.email' | translate }}</mat-label>
                  <input formControlName="email" matInput>
                  @if (formGroup.get('email')?.hasError('checkEmailOnServer')) {
                    <mat-error>
                      {{ 'checkEmailOnServer' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (user.showLoginType && +platformId === 6) {
                <mat-radio-group formControlName="loginType" class="login-type">
                  <mat-label>{{ 'frontUser.loginType' | translate }}</mat-label>
                  <mat-radio-button value="email">{{ 'frontUser.loginByEmail' | translate }}</mat-radio-button>
                  <mat-radio-button value="mobile">{{ 'frontUser.loginByMobile' | translate }}</mat-radio-button>
                  <mat-radio-button value="parent">{{ 'frontUser.loginByParent' | translate }}</mat-radio-button>
                </mat-radio-group>
              }
              @if ((isOrganizer && +platformId === 6)) {
                <div>
                  <mat-checkbox class="width-100" [(ngModel)]="noOrganization"
                                (ngModelChange)="checkNoOrganization($event)"
                                [ngModelOptions]="{standalone: true}">{{ 'frontUser.noOrganization' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (formGroup.get('countryId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                >
                  <mat-label>{{ 'user.country' | translate }}</mat-label>
                  <mat-select formControlName="countryId" required>
                    @for (country of countries; track country.id) {
                      <mat-option [value]="country.id">
                        {{ country.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('cityId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                >
                  <mat-label>{{ 'user.canton' | translate }}</mat-label>
                  <mat-select formControlName="cityId" required>
                    @for (city of cities; track city) {
                      <mat-option [value]="city.id">
                        {{ city.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('organizationId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                >
                  <mat-label>{{ 'user.organization' | translate }}</mat-label>
                  <mat-select formControlName="organizationId" required>
                    @for (org of organizations; track org.id) {
                      <mat-option [value]="org.id">
                        {{ org.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('tagId')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'main.tag' | translate }}</mat-label>
                  <mat-select formControlName="tagId" multiple>
                    @for (tag of tags; track tag) {
                      <mat-option [value]="tag.value">
                        {{ tag.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('lang')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'user.lang' | translate }}</mat-label>
                  <mat-select formControlName="lang" required>
                    @for (lang of languages; track lang) {
                      <mat-option [value]="lang.value">
                        {{ lang?.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('gender')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'user.gender' | translate }}</mat-label>
                  <mat-select formControlName="gender" required>
                    @for (gen of genders; track gen) {
                      <mat-option [value]="gen.value">
                        {{ gen?.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('street')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.street' | translate }}</mat-label>
                  <input formControlName="street" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('number')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.number' | translate }}</mat-label>
                  <input formControlName="number" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('postcode')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.postcode' | translate }}</mat-label>
                  <input formControlName="postcode" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('cityLocation')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.city' | translate }}</mat-label>
                  <input formControlName="cityLocation" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('phone')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.phone' | translate }}</mat-label>
                  <input formControlName="phone" matInput appPhoneMask>
                </mat-form-field>
              }
              @if (formGroup.get('mobile')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.mobile' | translate }}</mat-label>
                  <input formControlName="mobile" matInput appPhoneMask>
                </mat-form-field>
              }
              @if (formGroup.get('dateOfBirth')?.enabled) {
                <mat-form-field class="width-50">
                  <input matInput [matDatepicker]="picker1" placeholder="{{'user.dateOf_birth' | translate}}"
                         formControlName="dateOfBirth">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field>
              }
              @if (formGroup.get('abschlussjahr')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.abschlussjahr' | translate }}</mat-label>
                  <input formControlName="abschlussjahr" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('dateOfBaptism')?.enabled) {
                <mat-form-field class="width-50">
                  <input matInput [matDatepicker]="picker" placeholder="{{'user.dateOfBaptism' | translate}}"
                         formControlName="dateOfBaptism">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker disabled="false"></mat-datepicker>
                </mat-form-field>
              }
              @if (formGroup.get('dateOfConfirmation')?.enabled) {
                <mat-form-field class="width-50">
                  <input matInput [matDatepicker]="picker2" placeholder="{{'user.dateOfConfirmation' | translate}}"
                         formControlName="dateOfConfirmation">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2 disabled="false"></mat-datepicker>
                </mat-form-field>
              }
              @if (formGroup.get('introdactionDate')?.enabled) {
                <mat-form-field class="width-50">
                  <input matInput [matDatepicker]="picker3" placeholder="{{'user.introdactionDate' | translate}}"
                         formControlName="introdactionDate">
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3 disabled="false"></mat-datepicker>
                </mat-form-field>
              }
              @if (formGroup.get('targetGroupId')?.enabled) {
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'user.targetGroup' | translate }}</mat-label>
                  <mat-select formControlName="targetGroupId">
                    @for (tg of targetGroups; track tg) {
                      <mat-option [value]="tg.value">
                        {{ tg?.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('status')?.enabled) {
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'user.status-level' | translate }}</mat-label>
                  <mat-select formControlName="status" multiple>
                    @for (ls of levelStatuses; track ls) {
                      <mat-option [value]="ls.value">
                        {{ ls?.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('confessionId')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'user.confession' | translate }}</mat-label>
                  <mat-select formControlName="confessionId">
                    @for (cs of confessions; track cs) {
                      <mat-option [value]="cs.id">
                        {{ cs?.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('platformId')?.enabled && platforms.length) {
                <mat-form-field appearance="fill" class="width-50"
                >
                  <mat-label>{{ 'main.platforms' | translate }}</mat-label>
                  <mat-select formControlName="platformId">
                    @for (pl of platforms; track pl) {
                      <mat-option [value]="pl.id">
                        {{ pl?.title }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('notes')?.enabled) {
                <mat-form-field appearance="fill" class="width-100">
                  <mat-label>{{ 'user.notes' | translate }}</mat-label>
                  <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="5" formControlName="notes"></textarea>
                </mat-form-field>
              }
              @if (formGroup.get('showFoto')?.enabled) {
                <mat-checkbox class="width-50" formControlName="showFoto">{{ 'user.showFoto' | translate }}
                </mat-checkbox>
              }
              @if (formGroup.get('showChildrenName')?.enabled) {
                <mat-checkbox class="width-50"
                              formControlName="showChildrenName">{{ 'user.showChildrenName' | translate }}
                </mat-checkbox>
              }
              @if (formGroup.get('showNick')?.enabled) {
                <mat-checkbox class="width-50" formControlName="showNick">{{ 'user.showNick' | translate }}
                </mat-checkbox>
              }
              @if (formGroup.get('isMember')?.enabled) {
                <mat-checkbox class="width-50" formControlName="isMember">{{ 'user.isMember' | translate }}
                </mat-checkbox>
              }
            </form>
          </div>
        </div>
      }


      @if (!editing) {
        <div class="content content-read-only">
          @if (user) {
            <div class="content-block-read">
              <mat-tab-group dynamicHeight (selectedTabChange)="changeTab($event)"
                             [ngStyle]="{'background-color': (user.color ? colorShema[user.color] : colorShema['basic']) }">
                @if (user && user.verify) {
                  <mat-tab label="{{'Current' | translate}}">
                    <div style="display: flow-root;
    margin-right: 10px;">
                      @if (allTG.length) {
                        <input type="button" value="{{'main.addRewards' | translate}}"
                               (click)="openModal()"/>
                      }
                    </div>
                    <div class="main-profile">
                      @if (user) {
                        <div class="userInfo-div">
                          <div class="header-custom">
                            {{ 'Profile' | translate }}
                          </div>
                          @if ((user.logo || img) && user.showFoto) {
                            <div class="photo">
                              @if (user.logo && !img) {
                                <img
                                  [src]="getImage(user.logo)">
                              }
                              @if (img) {
                                <img [src]="getImage(img)">
                              }
                            </div>
                          }
                          <div class="photo">
                            @if (!user?.showFoto || (user?.showFoto && !user?.logo && user?.gender === 'diverse')) {
                              <div [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"
                                   class="user-photo color-logo-big"
                                   [style.backgroundColor]="(user?.logoColor && !user?.showFoto )? user?.logoColor : '#B0B0B0'">
                                {{ user.firstName && user.firstName[0] && user.firstName[0].toUpperCase() }}{{ user.lastName && user.lastName[0] && user.lastName[0].toUpperCase() }}
                              </div>
                            }
                          </div>
                          @if (!user.logo && !img) {
                            <div class="photo">
                              @if (user.frontRole.name === 'student' && user.gender === 'male' && user?.showFoto) {
                                <img
                                  [src]="'assets/images/studentMale.jpg'">
                              }
                              @if (user.frontRole.name === 'student' && user.gender === 'female' && user?.showFoto) {
                                <img
                                  [src]="'assets/images/studentFemale.jpg'">
                              }
                              @if (user.frontRole.name === 'parent' && user.gender === 'female' && user?.showFoto) {
                                <img
                                  [src]="'assets/images/mother.jpg'">
                              }
                              @if (user.frontRole.name === 'parent' && user.gender === 'male' && user?.showFoto) {
                                <img
                                  [src]="'assets/images/father.jpg'">
                              }
                            </div>
                          }
                          <div class="name">
                            {{ user.firstName + ' ' + user.lastName }}
                          </div>
                          <div class="birthday">
                            {{ user.dateOfBirth | date:'dd.L.yyyy' }}
                          </div>
                          @if (user.eventLevel) {
                            <div class="achievement-long">
                              <div class="achive">
                                <div class="achive-header">Auszeichnung</div>
                                <div class="achive-data">
                                  @for (item of user.eventLevel; track item) {
                                    <div>
                                      <img [src]="getImage(item.badge)"
                                           id="trophy">
                                      <label style="vertical-align: -webkit-baseline-middle;"
                                             for="trophy">{{ item.status ? (item.level + ' / ' + item.status) : item.level }}</label>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          @if (competencies?.length > 0) {
                            <div class="competency-header">{{ 'competency.competency' | translate }}</div>
                            @for (competency of competencies; track competency.id) {
                              <div class="competency-container">
                                <div class="competency" [style.border-color]="competency.color">
                                  {{ competency.title }}
                                </div>
                                @if (competency.skills) {
                                  @for (skill of competency.skills; track skill.id) {
                                    <div class="skill">
                                      - {{ skill.title }}:<b>{{ skill?.details?.length ?? 0 }}</b>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          }
                          @if (user && user.frontRoleId === 1) {
                            <div class="achievement-long">
                              <div class="achive">
                                <div class="achive-header">{{ 'privacyInfo' | translate }}</div>
                                <div class="achive-data">
                                  <div>
                                    <mat-checkbox [disabled]="true"
                                                  [(ngModel)]="user.showFoto">{{ 'user.showFoto' | translate }}
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <mat-checkbox [disabled]="true"
                                                  [(ngModel)]="user.showChildrenName">{{ 'user.showChildrenName' | translate }}
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <mat-checkbox [disabled]="true"
                                                  [(ngModel)]="user.showNick">{{ 'user.showNick' | translate }}
                                    </mat-checkbox>
                                  </div>
                                  @for (item of dynamicOrg; track item) {
                                    <div style="display: flex">
                                      <mat-checkbox [disabled]="true" [(ngModel)]="user.privacy[item.key]">
                                        {{ item.name }}
                                      </mat-checkbox>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @if (dataTGCurrent?.id && credits?.id) {
                        <div class="diagram-div">
                          <div class="header-custom">
                            {{ 'Score' | translate }}
                          </div>
                          <diagram [data]="dataTGCurrent" [update]="updateDate" [tgActive]="current"></diagram>
                          <div class="header-custom">
                            {{ 'total_score' | translate }}
                          </div>
                          <diagram [data]="credits" [update]="updateDate" [tgActive]="'all'"
                                   [allTG]="allTgIds"></diagram>
                        </div>
                      }
                      @if (events) {
                        <div class="events">
                          <div class="future-events">
                            <div class="header-custom"
                                 (click)="showBooked = !showBooked">{{ 'booked_programs' | translate }}
                              - {{ events.newEvents.length }} {{ 'main.participanAndWaiting' | translate }}
                              ({{ newEventsScore }} {{ 'user.creditTarget' | translate }})
                              @if (!showBooked) {
                                <mat-icon class="icon">keyboard_arrow_down</mat-icon>
                              }
                              @if (showBooked) {
                                <mat-icon class="icon">keyboard_arrow_up</mat-icon>
                              }
                            </div>
                            <div class="event-section" [hidden]="!showBooked">
                              @for (event of events.newEvents; track event) {
                                <div>
                                  <program-block
                                    [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.event?.credits) : (event?.eventType?.name + '     +' + event?.event?.credits)"
                                    [color]="event?.event?.eventType ? event?.event?.eventType?.color : event?.eventType?.color"
                                    [date]="event.date" [type]="'future'"
                                    [info]="event.event" [id]="(event.createdAt + 'e')"
                                    [isOnEvent]="event.isOnEvent ? 'true' : 'false'"></program-block>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="past-events">
                            <div class="header-custom"
                                 (click)="showEnded = !showEnded">{{ 'completed_programs' | translate }}
                              - {{ oldEventsScore }} {{ 'user.creditTarget' | translate }}
                              @if (!showEnded) {
                                <mat-icon class="icon">keyboard_arrow_down</mat-icon>
                              }
                              @if (showEnded) {
                                <mat-icon class="icon">keyboard_arrow_up</mat-icon>
                              }
                            </div>
                            <div class="event-section" [hidden]="!showEnded">
                              @for (event of events.oldEvents; track event) {
                                <div>
                                  <program-block
                                    [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.event?.credits) : (event?.eventType?.name + '     +' + event?.credits)"
                                    [color]="event?.event?.eventType ? event?.event?.eventType?.color : event?.eventType?.color"
                                    [date]="event.createdAt"
                                    [info]="event.event" [isOnEvent]="'reward'" [closed]="true"
                                    [completed]="!event.hasOwnProperty('isOnEvent') ? true : false"
                                    [allInfo]="event" [TGForRewards]="TGForRewards"
                                    [id]="(event.eventId + 'e')"
                                    (updateRewards)="updateRewards($event)"
                                    (deleteItem)="removeEventReward(event)"></program-block>
                                </div>
                              }
                              @for (event of events.manual; track event) {
                                <div>
                                  <program-block [codeInfo]="event.comment"
                                                 [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.credits) : (event?.eventType?.name + '     +' + event?.credits)"
                                                 [color]="(event?.event && event?.event?.eventType) ? event?.event?.eventType?.color : event?.eventType?.color"
                                                 [date]="event.createdAt"
                                                 [closed]="true" [allInfo]="event"
                                                 [info]="event.comment" [id]="(event.eventId + 'e')"
                                                 [completed]="true" [TGForRewards]="TGForRewards"
                                                 [isOnEvent]="+event.credits < 0 ? 'correction-' : 'correction+'"
                                                 (updateRewards)="updateAllRewards($event)"
                                                 (deleteItem)="removeReward($event, event.id)"></program-block>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (isParent) {
                        <div>
                          <ng-container *ngTemplateOutlet="clanview"></ng-container>
                        </div>
                      }
                    </div>
                  </mat-tab>
                }
                @if (user && user.verify && !user?.organization?.isGuest) {
                  <mat-tab label="{{'Scores' | translate}}">
                    <div class="tg-select">
                      <mat-form-field>
                        <mat-select [(value)]="selected" (selectionChange)="selectTg($event)" class="select-tg">
                          @for (tg of allTG; track tg) {
                            <mat-option [value]="tg.id">
                              @if (tg.current) {
                                {{ 'Current' | translate }} - {{ tg.ageMask }}
                              }
                              @if (!tg.current) {
                                {{ tg.ageMask }}
                              }
                            </mat-option>
                          }
                          @if (allTG.length > 1) {
                            <mat-option [value]="'all'">
                              <ng-container>{{ 'show_all' | translate }}</ng-container>
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    @if (user) {
                      <div class="main-profile">
                        <div>
                          @if (dataTGSelected.id) {
                            <div class="diagram-div">
                              <div class="header-custom">
                                {{ 'Score' | translate }}
                              </div>
                              <diagram [data]="dataTGSelected" [update]="updateDateSelected" [tgActive]="selected"
                                       [allTG]="allTgIds"></diagram>
                            </div>
                          }
                        </div>
                        @if (eventsScore) {
                          <div class="events">
                            <div class="future-events">
                              <div class="header-custom"
                                   (click)="showBooked = !showBooked">{{ 'booked_programs' | translate }}
                                - {{ events.newEvents.length }} {{ 'main.participanAndWaiting' | translate }}
                                ({{ newEventsScore }} {{ 'user.creditTarget' | translate }})
                                @if (!showBooked) {
                                  <mat-icon class="icon">keyboard_arrow_down</mat-icon>
                                }
                                @if (showBooked) {
                                  <mat-icon class="icon">keyboard_arrow_up</mat-icon>
                                }
                              </div>
                              <div class="event-section" [hidden]="!showBooked">
                                @for (event of eventsScore.newEvents; track event) {
                                  <div>
                                    <program-block
                                      [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.event?.credits) : (event?.eventType?.name + '     +' + event?.event?.credits)"
                                      [color]="event?.event?.eventType ? event?.event?.eventType?.color : event?.eventType?.color"
                                      [date]="event.createdAt"
                                      [info]="event.event" [id]="(event.createdAt + 'e')"
                                      [isOnEvent]="event.isOnEvent ? 'true' : 'false'"></program-block>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="past-events">
                              <div class="header-custom"
                                   (click)="showEnded = !showEnded">{{ 'completed_programs' | translate }}
                                - {{ oldEventsScore }} {{ 'user.creditTarget' | translate }}
                                @if (!showEnded) {
                                  <mat-icon class="icon">keyboard_arrow_down</mat-icon>
                                }
                                @if (showEnded) {
                                  <mat-icon class="icon">keyboard_arrow_up</mat-icon>
                                }
                              </div>
                              <div class="event-section" [hidden]="!showEnded">
                                @for (event of eventsScore.oldEvents; track event) {
                                  <div>
                                    <program-block
                                      [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.event?.credits) : (event?.eventType?.name + '     +' + event?.credits)"
                                      [color]="event?.event?.eventType ? event?.event?.eventType?.color : event?.eventType?.color"
                                      [date]="event.createdAt"
                                      [info]="event.event" [isOnEvent]="'reward'" [closed]="true"
                                      [completed]="!event.hasOwnProperty('isOnEvent') ? true : false"
                                      [allInfo]="event" [TGForRewards]="TGForRewards"
                                      [id]="(event.eventId + 'e')"
                                      (updateRewards)="updateAllRewards($event)"
                                      (deleteItem)="removeEventReward(event)"></program-block>
                                  </div>
                                }
                                @for (event of eventsScore.manual; track event) {
                                  <div>
                                    <program-block [codeInfo]="event.comment"
                                                   [title]="(event?.event && event?.event?.eventType) ? (event?.event?.eventType?.name + '     +' + event?.credits) : (event?.eventType?.name + '     +' + event?.credits)"
                                                   [color]="(event?.event && event?.event?.eventType) ? event?.event?.eventType?.color : event?.eventType?.color"
                                                   [date]="event.createdAt"
                                                   [closed]="true" [allInfo]="event"
                                                   [completed]="true" [TGForRewards]="TGForRewards"
                                                   [info]="event.comment" [id]="(event.eventId + 'e')"
                                                   [isOnEvent]="+event.credits < 0 ? 'correction-' : 'correction+'"
                                                   (updateRewards)="updateAllRewards($event)"
                                                   (deleteItem)="removeReward($event, event.id)"></program-block>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </mat-tab>
                }
                <mat-tab label="{{'Profile' | translate}}">
                  @if (user) {
                    <div>
                      <ng-container *ngTemplateOutlet="information"></ng-container>
                    </div>
                  }
                </mat-tab>
                @if (!isParent) {
                  <mat-tab label="{{'Timeline' | translate}}">
                    <time-line [timeLines]="timelines"></time-line>
                  </mat-tab>
                }
                @if (!isParent && user && user.verify) {
                  <mat-tab label="{{'Clan' | translate}}">
                    <div>
                      <ng-container *ngTemplateOutlet="clanview"></ng-container>
                    </div>
                  </mat-tab>
                }
              </mat-tab-group>
            </div>
          }
        </div>
      }
      <!-- / CONTENT -->

    </div>


  </div>
  <!-- / CENTER -->
</div>


<ng-template #information>

  <div class="general-info">
    <div class="header-custom">
      {{ 'general_Info' | translate }}
    </div>
    <div>
      <div class="user-info">
        <div class="uib">
          <div class="user-info-block">
            <div class="label">{{ 'canton.name' | translate }}</div>
            <div>{{ user.firstName + ' ' + user.lastName }}</div>
          </div>
          @if (!isParent) {
            <div class="user-info-block">
              <div class="label">{{ 'user.dateOf_birth' | translate }}</div>
              <div>{{ user?.dateOfBirth | date:'dd.L.yyyy' }}</div>
            </div>
          }
          @if (!isParent) {
            <div class="user-info-block">
              <div class="label">{{ 'user.dateOfBaptism' | translate }}</div>
              <div>{{ user?.dateOfBaptism | date:'dd.L.yyyy' }}</div>
            </div>
          }
          @if (!isParent) {
            <div class="user-info-block">
              <div class="label">{{ 'user.dateOfConfirmation' | translate }}</div>
              <div>{{ user?.dateOfConfirmation | date:'dd.L.yyyy' }}</div>
            </div>
          }
          @if (!isParent) {
            <div class="user-info-block">
              <div class="label">{{ 'user.introdactionDate' | translate }}</div>
              <div>{{ user?.introdactionDate | date:'dd.L.yyyy' }}</div>
            </div>
          }

          <!--<div class="user-info-block" *ngIf="!isParent">-->
          <!--<div class="label">{{'user.dateOfConfirmation' | translate}}</div>-->
          <!--<div>{{user?.dateOfConfirmation | date:'dd.L.yyyy'}}</div>-->
          <!--</div>-->
          <div class="user-info-block">
            <div class="label">{{ 'user.nickName' | translate }}</div>
            <div>{{ user?.nickName }}</div>
          </div>
        </div>
        <div class="uib">
          <div class="user-info-block">
            <div class="label">{{ 'user.email' | translate }}</div>
            <div>{{ user?.email }}</div>
          </div>
          <div class="user-info-block">
            <div class="label">{{ 'user.mobile' | translate }}</div>
            <div>{{ user.mobile }}</div>
            <div>{{ user.phone }}</div>
          </div>
          <div class="user-info-block">
            <div class="label">{{ 'user.abschlussjahr' | translate }}</div>
            <div>{{ user?.abschlussjahr }}</div>
          </div>
        </div>
      </div>
      <div class="canton-info">
        <div class="user-info-block">
          <div class="label">{{ 'user.canton' | translate }}</div>
          <div>{{ user?.city?.name }}</div>
        </div>
        <div class="user-info-block">
          <div class="label">{{ 'organization.name' | translate }}</div>
          <div>{{ user?.organization?.organizationType?.name }} {{ user?.organization?.name }}</div>
        </div>
      </div>
      <div class="canton-info">
        <div class="user-info-block">
          <div class="label">{{ 'main.confession' | translate }}</div>
          <div>{{ user?.confession?.name }}</div>
        </div>
        <div class="user-info-block">
        </div>
      </div>
      <div class="address-info">
        <div class="user-info-block">
          <div class="label">{{ 'organization.address' | translate }}</div>
          <div>{{ user?.street }} {{ user?.number }}</div>
          <div>{{ user?.postcode }} {{ user?.cityLocation }}</div>
        </div>
      </div>
    </div>
    <div class="canton-info">
      <div class="user-info-block">
        <div class="label">{{ 'user.notes' | translate }}</div>
        <div>{{ user?.notes }}</div>
      </div>
      <div class="user-info-block">
      </div>
    </div>
  </div>
</ng-template>

<ng-template #clanview>
  <div class="relatives">
    @for (item of clan; track item) {
      @if (item.users.length) {
        <div class="clan-block">
          <div class="header-custom-clan">
            <div class="line"></div>
            <div class="title">{{ 'clan.' + prefix + '_' + item.title | translate }}</div>
            <div class="line"></div>
          </div>
          <div class="users">
            @for (userItem of item.users; track userItem) {
              <div class="user">
                <div class="role">
                  @if (userItem.hasOwnProperty('noEmail') && userItem.noEmail) {
                    <i style="color: red"
                       class="material-icons" matTooltip="User withOut email">
                      mail_outline
                    </i>
                  }
                  @if (userItem.hasOwnProperty('isActive') && !userItem.isActive) {
                    <i style="color: red"
                       class="material-icons" matTooltip="Not active user">
                      error_outline
                    </i>
                  }
                  @if (userItem.hasOwnProperty('isActive') && userItem.isActive) {
                    <i style="color: green"
                       class="material-icons" matTooltip="Active user">
                      done_outline
                    </i>
                  }
                </div>
                <div class="name">
                  <div class="user-name">{{ userItem.name }}</div>
                  @if (userItem.representative) {
                    <div>
                      <mat-icon style="cursor: pointer; color: white; margin-left: 5px"
                                matTooltip="{{'representative' | translate}}">escalator_warning
                      </mat-icon>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</ng-template>
@if (backInProcess) {
  <div class="back-process">
    <div class="error">{{'frontUser.userNotFound' | translate}}</div>
    <div>{{'frontUser.returnVia' | translate}}: {{countdown}}</div>
  </div>
}
